import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Gift, TrendingUp, Wallet, Users } from 'lucide-react';

/**
 * Quick Actions card — 4-button grid: marketplace/subscribe, upgrade,
 * wallet, invite. Disabled state of "Upgrade Plan" is driven by `maxTier`.
 */
export function QuickActions({ user, maxTier, onOpenUpgrade }) {
  const isActive = user?.subscription_status === 'active';
  return (
    <Card className="bg-[#041A3B] border-white/10">
      <CardHeader>
        <CardTitle className="font-outfit text-white">Quick Actions</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-4">
          {isActive ? (
            <Link to="/marketplace">
              <Button className="w-full h-auto py-4 btn-secondary flex flex-col items-center gap-2" data-testid="browse-services-btn">
                <Gift className="w-6 h-6 text-[#00E5FF]" />
                <span>Browse Marketplace</span>
              </Button>
            </Link>
          ) : (
            <Link to="/pricing">
              <Button className="w-full h-auto py-4 btn-secondary flex flex-col items-center gap-2 border border-[#00E5FF]/30" data-testid="subscribe-now-btn">
                <TrendingUp className="w-6 h-6 text-[#00E5FF]" />
                <span className="text-[#00E5FF]">Subscribe Now</span>
              </Button>
            </Link>
          )}
          <Button
            onClick={onOpenUpgrade}
            disabled={maxTier}
            className="w-full h-auto py-4 btn-secondary flex flex-col items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
            data-testid="upgrade-plan-btn"
            title={maxTier ? "You're already on the highest tier" : 'Upgrade your plan'}
          >
            <TrendingUp className="w-6 h-6 text-[#00E676]" />
            <span>{maxTier ? 'Top Tier' : 'Upgrade Plan'}</span>
          </Button>
          <Link to="/wallet">
            <Button className="w-full h-auto py-4 btn-secondary flex flex-col items-center gap-2" data-testid="view-wallet-btn">
              <Wallet className="w-6 h-6 text-[#007AFF]" />
              <span>Wallet Details</span>
            </Button>
          </Link>
          <Link to="/referrals">
            <Button className="w-full h-auto py-4 btn-secondary flex flex-col items-center gap-2" data-testid="invite-friends-btn">
              <Users className="w-6 h-6 text-[#FFEA00]" />
              <span>Invite Friends</span>
            </Button>
          </Link>
        </div>
      </CardContent>
    </Card>
  );
}
